export default {"src":"/_next/static/media/voucher.e3d7c764.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};